import React, { useState, useEffect, useRef } from 'react';
import {
  Box,
  Header,
  Icon,
  Textarea,
  Button
} from '@cloudscape-design/components';

const ChatInterface = () => {
  const [chatMessages, setChatMessages] = useState([
    {
      id: 1,
      content: "Hi! I'm your Recapify assistant. How can I help you with your recordings?",
      type: 'assistant'
    }
  ]);
  const [chatInput, setChatInput] = useState('');
  const [isThinking, setIsThinking] = useState(false);
  const chatMessagesRef = useRef(null);

  useEffect(() => {
    if (chatMessagesRef.current) {
      chatMessagesRef.current.scrollTop = chatMessagesRef.current.scrollHeight;
    }
  }, [chatMessages]);

  const renderChatMessage = (message) => {
    const formatMessage = (content) => {
      return content
        .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
        .replace(/\n/g, '<br/>');
    };

    return (
      <Box key={message.id} padding="s" margin={{ bottom: 's' }}>
        <div style={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: '8px',
          flexDirection: message.type === 'user' ? 'row-reverse' : 'row'
        }}>
          {message.type === 'assistant' && (
            <div style={{
              minWidth: '24px',
              height: '24px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginTop: '4px'
            }}>
              <Icon name="settings" size="normal" />
            </div>
          )}
          <div style={{
            backgroundColor: message.type === 'user' ? '#e1f5fe' : '#f2f3f3',
            color: message.type === 'user' ? '#0d47a1' : 'black',
            padding: '8px 12px',
            borderRadius: '8px',
            maxWidth: '80%',
            wordWrap: 'break-word',
            whiteSpace: 'pre-line'
          }}>
            <Box fontSize="body-s">
              <div dangerouslySetInnerHTML={{ __html: formatMessage(message.content) }} />
            </Box>
          </div>
        </div>
      </Box>
    );
  };

  const handleChatSend = () => {
    if (chatInput.trim() && !isThinking) {
      const userMessage = {
        id: Date.now(),
        content: chatInput,
        type: 'user'
      };
      
      setChatMessages(prev => [...prev, userMessage]);
      setChatInput('');
      setIsThinking(true);
      
      const thinkingId = Date.now() + 1000;
      setChatMessages(prev => [...prev, {
        id: thinkingId,
        content: 'Thinking...',
        type: 'assistant',
        isThinking: true
      }]);
      
      setTimeout(() => {
        setChatMessages(prev => 
          prev.map(msg => 
            msg.id === thinkingId && msg.isThinking
              ? { ...msg, content: 'I understand your request. Let me help you with your recordings.', isThinking: false }
              : msg
          )
        );
        setIsThinking(false);
      }, 2000);
    }
  };

  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      height: '90vh',
      paddingBottom: '20px'
    }}>
      <Box padding={{ horizontal: 's', vertical: 's' }}>
        <Header variant="h2">AI Assistant</Header>
      </Box>
      
      <div style={{ 
        display: 'flex', 
        flexDirection: 'column', 
        flex: 1,
        gap: '16px',
        padding: '0 16px',
        minHeight: 0
      }}>
        <div 
          ref={chatMessagesRef}
          style={{ 
            flex: 1,
            overflowY: 'auto',
            border: '1px solid #e9ebed',
            borderRadius: '8px',
            padding: '8px',
            backgroundColor: '#fafbfc',
            minHeight: 0
          }}
        >
          {chatMessages.map((message) => renderChatMessage(message))}
        </div>
        
        <div style={{ 
          display: 'flex', 
          gap: '8px', 
          alignItems: 'flex-end',
          flexShrink: 0
        }}>
          <div style={{ flex: 1 }}>
            <Textarea
              value={chatInput}
              onChange={({ detail }) => setChatInput(detail.value)}
              placeholder="Type your message..."
              rows={1}
              disabled={isThinking}
            />
          </div>
          <Button 
            variant="primary" 
            onClick={handleChatSend}
            disabled={!chatInput.trim() || isThinking}
            iconName="send"
          >
            Send
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ChatInterface;
